<template>
  <b-col class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{$t('str.forum-tncs')}}
                </b-col>
                <b-col sm="9"></b-col>
              </b-row>
            </div>

            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4">{{$t('str.country')}}</b-col>
                    <b-col sm="4"><template v-if="$auth.session.get('role') == 'admin'">{{$t('str.office')}}</template>
                    </b-col>
                    <b-col sm="4"></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-select id="country_id" name="country_id" :plain="true" v-model="country_id"
                        style="height:100%;">
                        <option value="">{{$t('str.all')}}</option>
                        <option v-for="(c, index) in countrySelect" :value="c.value" :key="index">{{c.text}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="4">
                      <template v-if="$auth.session.get('role') == 'admin'">
                        <b-form-select id="office_id" name="office_id" :plain="true" v-model="office_id"
                          style="height:100%;">
                          <option value="">{{$t('str.all')}}</option>
                          <option v-for="(c, index) in officeSelect" :value="c.value" :key="index">{{c.text}}</option>
                        </b-form-select>
                      </template>
                    </b-col>
                    <b-col sm="4">
                      <buttons button-type="search" @click="getList()" />&nbsp;
                      <buttons button-type="reset_filter" @click="resetFilter()" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="8"></b-col>
                    <b-col sm="4">
                      <router-link style="float:right;" to="/office/forum/tnc/manage/0" class="btn-setting">
                        <buttons button-type="add_new" />
                      </router-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <p :class="{'text-center': true, 'd-none': items.length}" class="">{{$t('str.no-data')}}</p>
          <b-table :class="{'d-none': !items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="action" slot-scope="data">
              <router-link :to="'/office/forum/tnc/manage/'+data.item.id">
                <buttons button-type="edit" />
              </router-link>
              &nbsp;
              <template v-if="data.item.id > 1">
                <buttons button-type="delete" @click="confirmDelete(data.item.id)" />
              </template>
            </template>
          </b-table>
          <nav :class="{'d-none': !items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal :item="confirmDeleteId" @confirm="deleteData" @cancel="cancelDelete"></confirm-modal>
  </b-col>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'ForumTnc',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'countries', sortable: true },
        { key: 'offices', sortable: true },
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      confirmModal: false,
      confirmDeleteId: '',
      country_id: 0,
      countrySelect: [],
      office_id: 0,
      officeSelect: []
    }
  },
  methods: {
    async getAllCountry() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/ForumTnc/Country`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.countrySelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getAllOffice() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.officeSelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getList(page) {
      this.$auth.checkSession()

      let officerOffice = this.$auth.session.get('office')
      if (officerOffice) this.office_id = officerOffice

      let trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail += `&page=${page}`
      if (this.country_id != '') trail += `&country_id=${this.country_id}`
      if (this.office_id != '') trail += `&office_id=${this.office_id}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/ForumTnc${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data

        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    async deleteData(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.delete(`${this.$helper.envi.VUE_APP_API_URL}/ForumTnc/${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.country_code = ''
      this.getAllCountry()
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    },
    confirmDelete(id) {
      this.$auth.checkSession()
      this.confirmModal = true
      this.confirmDeleteId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmModal = false
    }
  },
  created() {
    this.getAllCountry()
    this.getAllOffice()
    this.getList()
  }
}
</script>